import script from "./DepthElement.vue?vue&type=script&setup=true&lang=js"
export * from "./DepthElement.vue?vue&type=script&setup=true&lang=js"

import "./DepthElement.vue?vue&type=style&index=0&id=5fe9c541&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fe9c541"]])

export default __exports__